import { esignDrawers } from '@sharefiledev/esign-pilet-sdk';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { signatureRequestDashboardPath, templateDetailsPath } from '../../routes';

export const getRedirectPath = (
	templateMetadata: { source?: string; redirectPath?: string },
	documentTemplateRid: string
): string => {
	if (templateMetadata?.source === 'esign') {
		return templateMetadata?.redirectPath || signatureRequestDashboardPath;
	}

	return templateDetailsPath
		.replace(':templateRID', encodeURIComponent(documentTemplateRid))
		.substring(1);
};

export const openEsignDrawer = (
	app: PiletApi,
	containerRID: string,
	documentRID: string,
	redirectPath: string,
	documentGenerationStatus: Record<string, boolean>
): void => {
	setTimeout(() => {
		app.showDrawer(esignDrawers.quickSendForSignatureDrawer, {
			params: {
				documentRID,
				redirectPath,
				containerRID,
				documentGenerationStatus,
			},
		});
	}, 0);
};
